import { render } from "./GenerationCapacity.vue?vue&type=template&id=1af8d2c6"
import script from "./GenerationCapacity.vue?vue&type=script&lang=js"
export * from "./GenerationCapacity.vue?vue&type=script&lang=js"

import "./GenerationCapacity.vue?vue&type=style&index=0&id=1af8d2c6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__